/** Circled-letter marks used on https://www.planneryapp.com/disclosures */
export const DisclosureMark = {
  Lending: 'Ⓛ',
  IndividualSavings: 'Ⓢ',
} as const;
